import { lpCertConfirm } from 'AssetsJsPath/backend/utils/confirm';

window.lpCertConfirm = lpCertConfirm;
